import Heading from '@atlaskit/heading';
import { Box, xcss, type BackgroundColor } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const bulletStyles = xcss({
  alignItems: 'center',
  display: 'flex',
  gap: 'space.200',
});

const iconStyles = xcss({
  alignItems: 'center',
  borderRadius: token('radius.small'),
  display: 'flex',
  flexShrink: '0',
  height: '24px',
  justifyContent: 'center',
  width: '24px',
});

const descriptionStyles = xcss({
  font: token('font.body.small'),
});

export const FeatureBullet = ({
  backgroundColor,
  icon: Icon,
  iconColor,
  title,
  description,
}: {
  backgroundColor: BackgroundColor;
  icon: React.ElementType;
  iconColor: string;
  title: string;
  description: string;
}) => {
  return (
    <Box as="li" xcss={bulletStyles}>
      <Box xcss={iconStyles} backgroundColor={backgroundColor}>
        <Icon label={title} color={iconColor} />
      </Box>
      <Box>
        <Heading size="xsmall">{title}</Heading>
        <Box xcss={descriptionStyles}>{description}</Box>
      </Box>
    </Box>
  );
};
